import { useTranslation } from 'next-i18next'
import clsx from 'clsx'
import { SizeVariant } from 'enums'

import { ButtonWithIcon } from 'components/buttons'
import { IconReply } from 'icons'

import UserInfo from '../UserInfo'

import { ICommentProps } from './types'

const Comment = ({ comment, className, onReplyComment }: ICommentProps) => {
  const { t } = useTranslation(['community'])
  return (
    <div className={clsx(className)}>
      <UserInfo
        avatar={comment.avatar}
        fullName={comment.fullName}
        createdAt={comment.createdAt}
      />
      <p className="mt-5">{comment.text}</p>
      <ButtonWithIcon
        className="mt-5 px-0 py-0"
        variant="secondary"
        size={SizeVariant.Small}
        swapped
        icon={IconReply}
        onClick={() => onReplyComment?.(comment.id)}
      >
        {t('reply', { ns: 'community' })}
      </ButtonWithIcon>
      {comment.replies?.map((reply) => (
        <Comment
          onReplyComment={onReplyComment}
          className="mt-5 border-l pl-5"
          key={reply.id}
          comment={reply}
        />
      ))}
    </div>
  )
}

export default Comment
